import React, { Component, useState, useEffect, useRef, useLayoutEffect } from 'react'

import { Link, useNavigate } from "react-router-dom"

import NewsletterHero from '../elements/NewsletterHero'
import Navbar from '../elements/Navbar'
import FeaturedCars from '../elements/FeaturedCars'
import ShareLease from '../elements/ShareLease'
import TheProcess from '../elements/TheProcess'
import Perferences from '../elements/Preferences'
import EmailList from '../elements/EmailList'
import Footer from '../elements/Footer'

const Home = (props) => {

    useEffect(() => {
        window.scrollTo(0,0);
    },[])

    useEffect(() => {
        document.title = 'AutoVitus - Newsletter'
    }, []);

    return (
        <div className='center' style={{width: '99.1vw', height: 'auto', backgroundColor: 'white', display: 'flex', flexDirection: 'column', overflowX: 'hidden'}}>
            <div style={{margin: 'auto', height: '100%', maxWidth: '1500px', paddingLeft: 'auto', paddingRight: 'auto'}}>
                <Navbar></Navbar>
                <NewsletterHero></NewsletterHero>
                <Footer style={{marginTop: '100px'}}></Footer>
            </div>
        </div>
    )
}

export default Home
